import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IChangePasswordRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useChangePassword() {
  const client = useApiClientUser()

  const changePasswordMutation = useMutation({
    mutationFn: async (props: IChangePasswordRequest) => {
      return await client.user
        .settingsControllerChangePassword(props, { secure: true })
        .then((res) => res.data)
    },
  })

  return {
    changePassword: changePasswordMutation.mutate,
    isRequesting: changePasswordMutation.isPending,
    error: getApiErrorMessage(
      changePasswordMutation.error,
      'Heslo sa nepodarilo zmeniť.'
    ),
    handleReset: changePasswordMutation.reset,
  }
}

export { useChangePassword }
